import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Check, FileText, Search } from "lucide-react";
import api from "@/lib/api";
import Orbits from "@/components/site/Orbits";

export default function Home() {
  const nav = useNavigate();
  const [c, setC] = useState({});
  useEffect(() => { api.get("/public/content").then(r => setC(r.data.content || {})).catch(() => {}); }, []);

  return (
    <>
      <section className="hero2">
        <Orbits />
        <div>
          <span className="pg-eyebrow">Medical second opinions · India</span>
          <h2>{c.hero_headline || "A second opinion, without the second-guessing."}</h2>
          <p className="sub">{c.hero_sub || "Have your diagnosis and reports reviewed by registered specialists, from wherever you are. Clear, considered guidance to help you and your treating doctor decide with confidence."}</p>
          <div className="hero-cta">
            <button className="pg-btn pg-btn-ink pg-btn-lg" onClick={() => nav("/book")} data-testid="hero-book">Book Consultation</button>
            <button className="pg-btn pg-btn-ghost pg-btn-lg" onClick={() => nav("/second-opinion")} data-testid="hero-why">Why a second opinion?</button>
          </div>
        </div>

        <div>
          <div className="verbox">
            <span className="tag">#2HC-0419</span>
            <div className="vbrandrow">
              <div className="vshield"><ShieldCheck size={26} /></div>
              <div className="v-logo">2</div>
              <div className="vname"><h1>2nd Opinion</h1><p>Health Consultants</p></div>
            </div>
            <h3>Only Verified Specialists</h3>
            <p>NMC&#8209;registered medical practitioners only.</p>
          </div>
          <div className="compliance-lines">
            <div><Check size={14} /> DPDP Act 2023 Compliant</div>
            <div><Check size={14} /> Telemedicine Practice Guidelines 2020 Compliant</div>
          </div>
        </div>
      </section>

      <div className="pgwrap" style={{ paddingTop: 0 }}>
        <div className="jr-head">
          <div>
            <span className="pg-eyebrow">From our desk</span>
            <h2 className="pg-h2" style={{ marginBottom: 0, fontFamily: "'Space Grotesk',monospace", color: "var(--green-deep)", fontSize: 36 }}>The Journal — Article of the month</h2>
          </div>
          <a style={{ color: "var(--pine)", fontSize: 14, cursor: "pointer" }} onClick={() => nav("/journal")} data-testid="home-all-articles">All articles →</a>
        </div>

        <div className="jr-feature clickable" onClick={() => nav("/journal")} data-testid="home-aom">
          <div className="body">
            <span className="pg-eyebrow">Article of the month</span>
            <h3>{c.article_title || "Health, explained without the jargon"}</h3>
            <p>{c.article_excerpt || "This month’s featured article from our specialists."}</p>
            <p style={{ marginTop: 14, color: "var(--pine)", fontSize: 14 }}>Read the article →</p>
          </div>
          <div className="art"><FileText size={40} /></div>
        </div>

        <div className="jr-feature clickable" style={{ marginTop: 18 }} onClick={() => nav("/second-opinion")} data-testid="home-so-teaser">
          <div className="body">
            <h3>When should you get a second opinion?</h3>
            <p>Not every diagnosis needs a second look — but some absolutely do.</p>
            <p style={{ marginTop: 14, color: "var(--pine)", fontSize: 14 }}>Read more →</p>
          </div>
          <div className="art"><Search size={40} /></div>
        </div>
      </div>

      <div className="pgwrap" style={{ paddingTop: 0 }}>
        <div className="mission2">
          <span className="pg-eyebrow">Our mission</span>
          <h2>{c.mission || "To make a trustworthy second opinion reachable for every patient in India."}</h2>
          <p>Too many serious decisions are made with lingering doubt. We connect you with registered specialists who review your case carefully and explain it in plain language — so the path forward is clearer for you and the doctor already caring for you.</p>
        </div>
      </div>
    </>
  );
}
